export default __webpack_public_path__ + "static/media/FilterActive.905c0429.svg";